module.exports = __webpack_public_path__ + "img/图1-36圆的徒手画法.6e3ab67d.png";